<!-- Copyright: Seán I. O'Donoghue -->
<!-- <template v-if="host !== 'vizbi.org'"> -->
<!-- The site's subtitle, always one line (Seán, 2026-10-22: it wrapped into the page below at
     the in-between widths): its size the largest that fits, up to 1.2rem (useMaxFontSize) -->

<template>
  <h2 ref="subtitleRef">Inspiring Life Science Breakthroughs. Cutting-Edge DataVis Advances.</h2>
</template>

<script setup>
import {ref} from "vue";
import {useMaxFontSize} from "@/composables/useMaxFontSize";
let host = window.location.host; //eslint-disable-line
const subtitleRef = ref(null);
useMaxFontSize(subtitleRef, {fillsWidth: true, maxFontSize: 19.2}); // 1.2rem, as before
</script>

<style scoped>
/* the title (VIZBI's logo text) sets the column's width; the subtitle fills it and no more:
   with no width of its own (width 0, at least the column's), it can't widen the header and push
   the menu out (2026-10-22); its size then fits that width (useMaxFontSize) */
h2 {
  width: 0;
  min-width: 100%;
  margin: 0;
  vertical-align: bottom;
  font-weight: 600;
  font-size: clamp(0.8rem, 3vw, 1.2rem);
  line-height: 140%;
  color: var(--subtitle-color);
  opacity: 100%;
}
/* .darkMode h2 {
  opacity: 100%;
}
.wide h2 {
  opacity: 50%;
}
.medium h2 {
  opacity: 70%;
} */
/* .narrow h2 {
  display: block;
  font-size: clamp(1rem, 5vw, 1.5rem);
  line-height: clamp(1.5rem, 5vw 2rem);
} */
</style>
